import { FC } from "react";
import { DIAGNOSTICS_STEPS_VALUES, EXCLUSIVE_STEPS } from "@/constants/diagnostics";
import { useClientHeight } from "@/hooks/useClientHeight";
import { selectDiagnosticsStep } from "@/store/features/diagnostics/selectors";
import { useAppSelector } from "@/store/hooks";
import { StyledDiagnosticsSection, StyledDiagnosticsSectionContent } from "./styled";

interface Props {
  id: string;
  children: React.ReactNode;
}

const DiagnosticsSection: FC<Props> = ({ children, id }) => {
  const height = useClientHeight();

  const step = useAppSelector(selectDiagnosticsStep);

  const sectionStep = +DIAGNOSTICS_STEPS_VALUES[id];

  return (
    <StyledDiagnosticsSection id={id} $active={sectionStep === step} $isExclusive={EXCLUSIVE_STEPS.includes(step)} $height={height}>
      <StyledDiagnosticsSectionContent>
        {children}
      </StyledDiagnosticsSectionContent>
    </StyledDiagnosticsSection>
  );
};

export default DiagnosticsSection;